import { render, staticRenderFns } from "./UnsignedTask.vue?vue&type=template&id=3784e1ba&scoped=true"
import script from "./UnsignedTask.vue?vue&type=script&lang=js"
export * from "./UnsignedTask.vue?vue&type=script&lang=js"
import style0 from "./UnsignedTask.vue?vue&type=style&index=0&id=3784e1ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3784e1ba",
  null
  
)

export default component.exports